// User Service - OOP Business Logic
import { UserRepository, CreateUserPayload, UpdateUserPayload } from '../repositories/UserRepository';
import { IUser } from '../interfaces/IUser';

export class UserService {
  constructor(private userRepository: UserRepository) {}

  async createUser(data: CreateUserPayload): Promise<IUser> {
    return this.userRepository.create(data);
  }

  async getAllUsers(): Promise<IUser[]> {
    return this.userRepository.getAll();
  }

  async getUserById(id: string): Promise<IUser> {
    return this.userRepository.getById(id);
  }

  async updateUser(id: string, data: UpdateUserPayload): Promise<IUser> {
    return this.userRepository.update(id, data);
  }

  async resendInvite(userId: string): Promise<{ message: string }> {
    return this.userRepository.resendInvite(userId);
  }

  async deleteUser(id: string): Promise<void> {
    return this.userRepository.delete(id);
  }

  isAdmin(user: IUser): boolean {
    return user.roles.some((role) => role === 'admin');
  }

  isActive(user: IUser): boolean {
    return user.isActive;
  }

  hasRole(user: IUser, roleName: string): boolean {
    return user.roles.some((role) => role === roleName);
  }

  getRoleNames(user: IUser): string[] {
    return user.roles;
  }

  async toggleUserActive(userId: string, isActive: boolean): Promise<IUser> {
    return this.userRepository.update(userId, { isActive });
  }
}
